<div class="error-page-container">
  <div class="error-page">
    <div class="error-card" *ngIf="statusCode == '404'">
      <div class="error-card-body">
        <div class="error-icon">
          <h1>:(</h1>
        </div>
        <div class="error-message">
          <span class="error-header">404 - Page not found</span>
          <span class="error-description">The page you are looking for might have been removed had its name changed or is temporarily unavailable.</span>
          <div class="error-card-button-group">
            <button class="home-page-btn" (click)="goToHome()">
              home page
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="error-card" *ngIf="statusCode == '401'">
      <div class="error-card-body">
        <div class="error-icon unautherized">
          <img src="assets/images/lock-shield.svg" />
        </div>
        <div class="error-message">
          <span class="error-header">401 - Access Denied</span>
          <span class="error-description">You do not have access to this account.</span>
          <span class="error-description">If you believe this is a mistake, please contact to support team or the account administrator.</span>
          <div class="error-card-button-group">
            <button class="home-page-btn" (click)="goToHome()">
              home page
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="error-card" *ngIf="statusCode == '402'">
      <div class="error-card-body">
        <div class="error-icon unautherized">
          <img src="assets/images/lock-shield.svg" />
        </div>
        <div class="error-message">
          <span class="error-header">402 - Access Restricted</span>
          <span class="error-description">You are not allowed to access this resource.</span>
          <span class="error-description">If you think this is an error or have questions about your access, please contact support or the administrator.</span>
          <div class="error-card-button-group">
            <button class="home-page-btn" (click)="goToHome()">
              home page
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="error-card" *ngIf="statusCode == '403'">
      <div class="error-card-body">
        <div class="error-icon unautherized">
          <img src="assets/images/lock-shield.svg" />
        </div>
        <div class="error-message">
          <span class="error-header">403 - Access Denied</span>
          <span class="error-description">The details you provided are incorrect, or you are not authorized to access this account.</span>
          <span class="error-description">Please verify your information and try again.
            If you believe this is an error, contact support or the account administrator for assistance.</span>
          <div class="error-card-button-group">
            <button class="home-page-btn" (click)="goToHome()">
              home page
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="error-card" *ngIf="statusCode == '405'">
      <div class="error-card-body">
        <div class="error-icon unautherized">
          <img src="assets/images/lock-shield.svg" />
        </div>
        <div class="error-message">
          <span class="error-header">405 - Invalid URL</span>
          <span class="error-description">The page you’re trying to access doesn’t exist or the URL has been modified</span>
          <span class="error-description">Please check the link and try again.
            If you believe this is an error, contact support for assistance.</span>
          <div class="error-card-button-group">
            <button class="home-page-btn" (click)="goToHome()">
              Home page
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="error-card" *ngIf="statusCode == '406'">
      <div class="error-card-body">
        <div class="error-icon unautherized">
          <img src="assets/images/lock-shield.svg" />
        </div>
        <div class="error-message">
          <span class="error-header">406 - Unsupported Type</span>
          <span class="error-description">The action you’re trying to perform involves an unsupported type.</span>
          <span class="error-description">Please ensure you’re using a valid type and try again.
            If you need assistance, contact support for more information.</span>
          <div class="error-card-button-group">
            <button class="home-page-btn" (click)="goToHome()">
              Home page
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
